import "./ButtonComp.css";
import { defineComponent as r, resolveComponent as s, openBlock as t, createBlock as o, resolveDynamicComponent as p, normalizeClass as i, withCtx as u, renderSlot as n, createCommentVNode as a } from "vue";
import { WaitingComp as c } from "./WaitingComp.js";
import { IconComp as h } from "./IconComp.js";
import { _ as y } from "./_plugin-vue_export-helper.dad06003.js";
const f = r({
  components: {
    WaitingComp: c,
    IconComp: h
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      default: !1
    },
    medium: {
      type: Boolean,
      default: !1
    },
    large: {
      type: Boolean,
      default: !1
    },
    xlarge: {
      type: Boolean,
      default: !1
    },
    navWhite: {
      type: Boolean,
      default: !1
    },
    navGray: {
      type: Boolean,
      default: !1
    },
    selectGray: {
      type: Boolean,
      default: !1
    },
    selectWhite: {
      type: Boolean,
      default: !1
    },
    dropdown: {
      type: Boolean,
      default: !1
    },
    dropdownSelected: {
      type: Boolean,
      default: !1
    },
    dropdownDisabled: {
      type: Boolean,
      default: !1
    },
    blue: {
      type: Boolean,
      default: !1
    },
    gray: {
      type: Boolean,
      default: !1
    },
    legacyOrange: {
      type: Boolean,
      default: !1
    },
    legacyBlue: {
      type: Boolean,
      default: !1
    },
    legacySecondary: {
      type: Boolean,
      default: !1
    },
    blank: {
      type: Boolean,
      default: !1
    },
    anchorStyle: {
      type: Boolean,
      default: !1
    },
    /**
     * When set to true, this component is rendering as a `<router-link></router-link>`, which means you also need to pass a `to` prop
     */
    routerLink: {
      type: Boolean,
      default: !1
    },
    /**
     * When set to true, this component will render as a `<a></a>` tag
     */
    anchorTag: {
      type: Boolean,
      default: !1
    },
    waiting: {
      type: Boolean,
      default: !1
    },
    prependIcon: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "button"
    }
  },
  computed: {
    componentType() {
      return this.routerLink ? this.showDisabled ? "span" : "router-link" : this.anchorTag ? "a" : "button";
    },
    classObject() {
      return {
        "button--disabled": this.showDisabled && !this.isCustomButtonStyle && !this.dropdown,
        "button--small": this.small,
        "button--medium": this.medium || this.defaultSize,
        "button--large": this.large,
        "button--xlarge": this.xlarge,
        "button--blank": this.blank,
        "button--navWhite": this.navWhite,
        "button--navGray": this.navGray,
        "button--selectGray": this.selectGray,
        "button--selectWhite": this.selectWhite && !this.showDisabled,
        "button--selectWhiteDisabled": this.selectWhite && this.showDisabled,
        "button--dropdown": this.dropdown,
        "button--dropdownSelected": this.dropdownSelected,
        "button--dropdownDisabled": this.dropdownDisabled,
        "button--legacyOrange": this.legacyOrange,
        "button--legacyBlue": this.legacyBlue,
        "button--legacySecondary": this.legacySecondary,
        "button--blue": this.blue,
        "button--gray": this.gray,
        "button--anchorStyle": this.anchorStyle,
        "button--waiting": this.waiting,
        "button--routerlink": this.routerLink
      };
    },
    appendedIconClasses() {
      return {
        "button--appendIcon": !0,
        "button--appendIcon--small": this.small
      };
    },
    defaultSize() {
      return !this.small && !this.medium && !this.large && !this.isCustomButtonStyle;
    },
    showDisabled() {
      return this.disabled || this.waiting || this.dropdownDisabled;
    },
    waitingSize() {
      return this.small ? "10px" : "20px";
    },
    showAppendIcon() {
      return !!this.appendIcon && !this.waiting;
    },
    showPrependIcon() {
      return !!this.prependIcon && !this.small && !this.waiting;
    },
    isCustomButtonStyle() {
      return this.blank || this.anchorStyle || this.selectWhite || this.selectGray;
    }
  }
});
function b(e, m, g, w, B, S) {
  const l = s("icon-comp"), d = s("waiting-comp");
  return t(), o(p(e.componentType), {
    class: i(["button", e.classObject]),
    disabled: e.showDisabled,
    type: e.type
  }, {
    default: u(() => [
      n(e.$slots, "prepend", {}, () => [
        e.showPrependIcon ? (t(), o(l, {
          key: 0,
          class: "button--prependIcon",
          icon: e.prependIcon
        }, null, 8, ["icon"])) : a("", !0)
      ]),
      n(e.$slots, "default"),
      e.waiting ? (t(), o(d, {
        key: 0,
        class: "button--waiting",
        size: e.waitingSize,
        secondaryGray: ""
      }, null, 8, ["size"])) : a("", !0),
      n(e.$slots, "append", {}, () => [
        e.showAppendIcon ? (t(), o(l, {
          key: 0,
          class: i(e.appendedIconClasses),
          icon: e.appendIcon
        }, null, 8, ["class", "icon"])) : a("", !0)
      ])
    ]),
    _: 3
  }, 8, ["class", "disabled", "type"]);
}
const v = /* @__PURE__ */ y(f, [["render", b], ["__scopeId", "data-v-c96371dd"]]);
export {
  v as ButtonComp
};
//# sourceMappingURL=ButtonComp.js.map
